import { Injectable } from '@angular/core';
import { Resolve, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Store } from '@ngxs/store';
import { NgxsActionHelper } from 'app/projects/core/src/lib/services/action.helper';
import { Observable } from 'rxjs';
import { FetchCourseStructureCategory, FetchCourseStructureCategoryFailure, FetchCourseStructureCategorySuccess } from '../actions';

@Injectable()
export class CourseStructureCategoryResolver implements Resolve<boolean> {
    constructor(private store: Store, private actionHelper: NgxsActionHelper) {}

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        const categoryId = route.params['id'];
        this.store.dispatch([new FetchCourseStructureCategory(categoryId)]);

        return this.actionHelper.race(FetchCourseStructureCategorySuccess, FetchCourseStructureCategoryFailure);
    }
}
